const feedbackStrings = {
  title: ["COMENTARIOS", "Cuéntanos qué opinas"],
  message: `<p>Gracias por tomarte el tiempo de responder algunas preguntas cortas. Tus comentarios son muy importantes para nosotros y muchas de las características de ABCya son el resultado directo de comentarios que hemos recibido a través de este formulario. ¡Agradecemos tu ayuda!</p><p>Todos los campos de este formulario son opcionales y, si necesitas asistencia técnica, por favor ponte en contacto con <a href="/soporte">el servicio al cliente de ABCya</a>.</p>`,
  choose: "ELIGE TU ROL",
  contact: "Introduce tu información de contacto",
  terms:
    'Al hacer clic en ENVIAR, confirmas que has leído y aceptado nuestra <a href="/privacidad" rel="noopener noreferrer" target="_blank">Política de Privacidad</a>.',
  submitted: {
    message: "¡Te agradecemos tus comentarios y sugerencias!",
  },
  questions: {
    title: "Deja tus comentarios y sugerencias",
    data: {
      all: [
        "¿Cómo descubriste ABCya? ¿Qué buscabas en ese momento?",
        "¿Actualmente utilizas otras apps o sitios web educativos? En caso afirmativo, ¿cuáles son?",
        "¿Qué es lo que más te gusta de ABCya? ¿Por qué?",
        "¿Qué temas/lecciones te gustaría que ABCya incluyera?",
        "¿Tienes algún comentario o pregunta adicional?",
        {
          text: "¿Podemos compartir tus comentarios con otros miembros de la comunidad de ABCya?",
          answers: [
            { value: "Sí, pueden compartir mis comentarios utilizando mi nombre." },
            { value: "Sí, pueden compartir mis comentarios, pero por favor no utilicen mi nombre." },
            { value: "No, por favor, no compartan mis comentarios.", checked: true },
          ],
        },
      ],
      parent: [
        "Háblanos de ti o de tu familia.",
        "¿Qué uso hace tu familia de ABCya?",
        "¿De qué forma ha contribuido ABCya a que tus hijos tengan más éxito en su aprendizaje?",
        "¿Cuáles son tus mayores desafíos como padre/madre?",
      ],
      teacher: [
        "Háblanos de ti y de tus estudiantes. ¿Qué grados y asignaturas enseñas?",
        "¿Cómo utilizas ABCya con tus estudiantes? ¿Cómo ha influenciado ABCya la forma en la que enseñas?",
        "¿Cómo ha contribuido ABCya a facilitar el aprendizaje de tus estudiantes?",
        "¿Cuáles son tus mayores desafíos como docente?",
      ],
    },
  },
};

export default feedbackStrings;
